import axios from 'axios';
import {getApiConfig} from '../config/configProvider';

const getBaseUrl = () => {
  const config = getApiConfig();
  return config && config.invoiceScanningUrl
    ? config.invoiceScanningUrl
    : '/api/invoice-scanning/api/customer/invoices';
};

export default class InvoiceUploadApi {
  static upload(files, headers) {
    const url = getBaseUrl();
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    return axios
      .post(`${url}/upload`, formData, {
        headers: {
          ...headers,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(res => res.data);
  }

  static list(page, pageSize, headers) {
    const url = getBaseUrl();
    return axios
      .get(url, {headers, params: {page, pageSize}})
      .then(res => res.data);
  }

  static getDetail(id, headers) {
    const url = getBaseUrl();
    return axios.get(`${url}/${id}`, {headers}).then(res => res.data);
  }
}
